import { render, staticRenderFns } from "./HardwareForm.vue?vue&type=template&id=0ba840ba&scoped=true&"
import script from "./HardwareForm.vue?vue&type=script&lang=js&"
export * from "./HardwareForm.vue?vue&type=script&lang=js&"
import style0 from "./HardwareForm.vue?vue&type=style&index=0&id=0ba840ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba840ba",
  null
  
)

export default component.exports